import * as Sentry from '@sentry/gatsby';
import { sentryConfigActivationLitterDataCapture } from '@agria/utils/src/sentryConfigActivationLitterDataCapture';

Sentry.init(sentryConfigActivationLitterDataCapture);
